<template>
  <div>
    <router-link
      v-if="link"
      :to="{ name: 'users', params: { user_id: user.id } }"
    >
      {{ user.first_name | capitalize }} {{ user.last_name | capitalize }}
    </router-link>
    <span v-else>
      {{ user.first_name | capitalize }} {{ user.last_name | capitalize }}
    </span>
  </div>
</template>

<script>
export default {
  name: "User",
  props: {
    user: {
      type: Object,
    },
    link: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
}
</script>
